import type { FaireProductEntity } from "../../entity_types/product";

export const p_6a7s4jw94j: FaireProductEntity = {
  token: "p_6a7s4jw94j",
  type: "product",
  name: "Temperament Wide Leg Straight Leg Suit Pants",
  brandToken: "b_jkhzdth9kx",
  brandName: "Wholesalesir",
  imageUrl:
    "https://cdn.faire.com/fastly/dd962fa9471c72d516d974887d2dcc88a72903e11af0a095792714db839665a2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/43fec5495d32c5a342140c619d0142fc2b48f77dbd95fddfcb70894a0949e26b.jpeg",
    "https://cdn.faire.com/fastly/3ad9b762c3f9bc0350490b3dfb42aef40e604c1de2981af3747f69830db88cf6.png",
    "https://cdn.faire.com/fastly/adfe36718a48a55f050f662e69b8dc07087d0debe6ca8e44f6cb451449daccd1.jpeg",
    "https://cdn.faire.com/fastly/4e8726707d3df002cd3f34b020ffbf45b2c5b2a68e52e9c7713ae379f335061f.jpeg",
    "https://cdn.faire.com/fastly/99dfa194bc0c04f301df045f9853b8da375f4edd9b76b625bc82d34797a37137.jpeg",
    "https://cdn.faire.com/fastly/3cc0608d2ca6319f1162d2edeeff1540c0f841036f81d37f1cfc1be17a30202e.jpeg",
  ],
  priceDollars: 26.26,
  description:
    "100% Polyester,The fabric is soft, skin-friendly and very comfortable and light\nImported\nMachine Wash\nFeatures:Long pants\n Occasion: Suitable to Wear in Many Occasions, Such as Daily Life, Home, Outing, Vacation, Work, Weekend, Holiday, Casual, Dating, Walk after Supper, Picnic and Any Time in Summer\nSize：Please carefully check the size chart before placing an order.Manual measurement of size",
  tags: [],
  msrpDollars: 52.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:40.413Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
